import { Container, Paper, TablePagination } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';
import MaterialTable from 'material-table';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PageHeader } from '../common/pageHeader';
import { horsesService } from '../_services/horse.service';
import { toastr } from '../_components/toastr';
import { format } from 'date-fns';



interface ITableData {
    items: Array<any>;
    count: number;
}

interface IFilteringViewModel {
    search: string;
    limit: number;
    page: number;
    order?: 'asc' | 'desc';
    orderBy: string;
    [key: string]: any;
}

enum FilterEnum {
    search = 'search',
    limit = 'limit',
    page = 'page',
    order = 'order',
    orderBy = 'orderBy'
}

const useStyles = makeStyles(theme => ({
    pageHeader: {
        borderBottom: "1px solid #eee"
    }
}));

export function UploadHorsesView() {

    const [data, setData] = useState<ITableData>({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel>({ search: '', limit: 5, page: 0, order: 'asc', orderBy: '', uploadId: 0 });

    const classes = useStyles();
    const { uploadId } = useParams<{ uploadId: string }>();

    const columns = [
        { title: 'Name', field: 'horseName', render: (rowData: any) => <div>{(rowData.horseName)}<br></br>({(rowData.parents)})</div> },
        { title: 'Category', field: 'categoryName' },
        { title: 'DOB', field: 'dateOfBirth', render: (rowData: any) => <>{format(new Date(rowData.dateOfBirth), 'dd/MM/yyyy')}</> },
        { title: 'GenderName', field: 'genderName' },
    ];

    useEffect(() => { fetchData() }, []);

    function fetchData() {
        setLoading(true);
        filter.uploadId = uploadId;
        return horsesService.getAllForFile(filter)
            .then(json => {
                json.items = json.items || [];
                setData(json);
            }, (e) => { console.log(e); toastr.error("Something went wrong. Please try again later"); })
            .finally(() => { console.log("DONE4"); setLoading(false); });
    }

    function setProp(propName: FilterEnum, propValue: any) {
        const query = filter;
        query[propName.toString()] = propValue;
        setFilter({ ...query });
        fetchData();
    }

    function handleRequestSort(property: string) {
        const query = filter;
        query.orderBy = property;
        let order: 'asc' | 'desc' = 'desc';

        if (filter.orderBy === property && filter.order === 'desc') {
            order = 'asc';
        }

        query.order = order;

        setFilter({ ...query });
        fetchData();
    }

    function createUploadPostBack(): void { }

    return (
        <>
            <Container component="main">


                <Paper>
                    <CssBaseline />

                    <div className={classes.pageHeader}>
                        <PageHeader title='File Upload Horses' icon='cloud_upload'></PageHeader>
                    </div>

                    <MaterialTable
                        columns={columns}
                        data={data.items}
                        isLoading={isLoading}
                        onSearchChange={(propValue) => setProp(FilterEnum.search, propValue)}
                        components={{
                            Pagination: (componentProps) => <TablePagination
                                {...componentProps}
                                count={data.count}
                                onChangePage={(e, propValue) => setProp(FilterEnum.page, propValue)}
                                onChangeRowsPerPage={(e) => setProp(FilterEnum.limit, e.target.value)}
                                page={filter.page}
                                rowsPerPage={filter.limit}
                            />,
                            Header: d =>
                                <TableHead>
                                    <TableRow>
                                        {columns && columns.map(h =>
                                            <TableCell key={h.title}
                                                sortDirection={filter.orderBy === h.field ? filter.order : false}>
                                                <Tooltip
                                                    title="Sort"
                                                    enterDelay={300}>
                                                    <TableSortLabel
                                                        active={filter.orderBy === h.field}
                                                        direction={filter.order}
                                                        onClick={e => handleRequestSort(h.field)}>
                                                        {h.title}
                                                    </TableSortLabel>
                                                </Tooltip>
                                            </TableCell>
                                        )}
                                    </TableRow>

                                </TableHead>
                        }}
                        options={{
                            search: true,
                            toolbar: true,
                            pageSize: filter.limit,
                            pageSizeOptions: [5, 10, 20, 50, 100],
                            initialPage: 0,
                            showEmptyDataSourceMessage: true,
                            sorting: true,
                            showTitle: false,
                            loadingType: 'linear',
                            debounceInterval: 200,
                        }}


                    />
                </Paper>
            </Container>
        </>
    );
}